import React, { useState } from 'react'
import AdminPurchaseEntryNew from './AdminPurchaseEntryNew'
import AdminInvoiceEntryNew from './AdminInvoicEntryNew';
import QuotationNew from './QuotationNew';

const inoviceDefaultValues = {
  skus: [],
  paymentTypes: [],
  invoiceNumber:"",
  invoiceDate: new Date().toISOString().split("T")[0],
  customerName:"",
  Mobile:"",
  TotalFineGold:"",
  advanceamount:"",
  balanceamount:""

};
const AdminCreateInvoiceEntryNew = () => {
  const [editStatus,setEditStatus] = useState(false)

  console.log(inoviceDefaultValues);
  

  return (
    <>
    
   <AdminInvoiceEntryNew
   editStatus={editStatus}
   defaultValues={inoviceDefaultValues}
   />


   {/* <QuotationNew
   
    editStatus={editStatus}
    defaultValues={inoviceDefaultValues}
   /> */}
   
   </>
  )
}

export default AdminCreateInvoiceEntryNew
